import { z } from 'zod'
import { supabase } from '../lib/supabase'

export const PERMESSI_VALIDI = [
  'dichiarazioni_ad1',
  'scadenziari',
  'registri_letture',
  'praticheenergia_green',
  'vede_tutti_impianti',
  'gestione',
] as const
export type Permesso = (typeof PERMESSI_VALIDI)[number]

export const SchemaOperatore = z.object({
  email: z.email('Indirizzo email non valido'),
  nome: z.string().min(1, 'Il nome e obbligatorio'),
  permessi: z.array(z.enum(PERMESSI_VALIDI, { error: 'Permesso non valido' })),
})
export type DatiOperatore = z.infer<typeof SchemaOperatore>

export async function elencaAccount() {
  const { data, error } = await supabase
    .from('account')
    .select('id, email, nome, account_permesso(permesso)')
    .order('nome')
  if (error) throw new Error(error.message)
  return data
}

/** La creazione passa da una Edge Function: creare un utente auth richiede la service key. */
export async function creaOperatore(dati: DatiOperatore) {
  const v = SchemaOperatore.safeParse(dati)
  if (!v.success) throw new Error(v.error.issues[0]!.message)
  const { data, error } = await supabase.functions.invoke('crea-operatore', { body: v.data })
  if (error) throw new Error(error.message)
  return data
}

/** Sostituisce l'intero insieme: cancella e reinserisce, non fa merge. */
export async function aggiornaPermessi(accountId: number, permessi: readonly Permesso[]) {
  const del = await supabase.from('account_permesso').delete().eq('account_id', accountId)
  if (del.error) throw new Error(del.error.message)
  if (permessi.length === 0) return
  const ins = await supabase
    .from('account_permesso')
    .insert(permessi.map((p) => ({ account_id: accountId, permesso: p })))
  if (ins.error) throw new Error(ins.error.message)
}

export async function eliminaAccount(accountId: number) {
  const { error } = await supabase.from('account').delete().eq('id', accountId)
  if (error) throw new Error(error.message)
}
